import contacts_KR from '../../assets/i18n/messages_contacts_ko_KR.json';
import contacts_US from '../../assets/i18n/messages_contacts_en_US.json';
import contacts_JP from '../../assets/i18n/messages_contacts_ja_JP.json';
import contacts_CN from '../../assets/i18n/messages_contacts_zh_CN.json';
import contacts_TW from '../../assets/i18n/messages_contacts_zh_TW.json';
import contacts_VN from '../../assets/i18n/messages_contacts_vi_VN.json';
import contacts_FR from '../../assets/i18n/messages_contacts_fr_FR.json';

import brity_contacts_KR from '../../assets/i18n/brityMail/messages_contacts_ko_KR.json';
import brity_contacts_US from '../../assets/i18n/brityMail/messages_contacts_en_US.json';
import brity_contacts_JP from '../../assets/i18n/brityMail/messages_contacts_ja_JP.json';
import brity_contacts_CN from '../../assets/i18n/brityMail/messages_contacts_zh_CN.json';
import brity_contacts_TW from '../../assets/i18n/brityMail/messages_contacts_zh_TW.json';
import brity_contacts_VN from '../../assets/i18n/brityMail/messages_contacts_vi_VN.json';
import brity_contacts_FR from '../../assets/i18n/brityMail/messages_contacts_fr_FR.json';

import gov_contacts_KR from '../../assets/i18n/gov/messages_contacts_ko_KR.json';
import gov_contacts_US from '../../assets/i18n/gov/messages_contacts_en_US.json';
import gov_contacts_JP from '../../assets/i18n/gov/messages_contacts_ja_JP.json';
import gov_contacts_CN from '../../assets/i18n/gov/messages_contacts_zh_CN.json';
import gov_contacts_TW from '../../assets/i18n/gov/messages_contacts_zh_TW.json';
import gov_contacts_VN from '../../assets/i18n/gov/messages_contacts_vi_VN.json';
import gov_contacts_FR from '../../assets/i18n/gov/messages_contacts_fr_FR.json';

const isKnox = window.location.hostname.indexOf('samsung.net') !== -1;

const LANGUAGES = {
  en_US: 'en',
  ko_KR: 'ko',
  ja_JP: 'ja',
  zh_CN: 'zh',
  zh_TW: 'tw',
  vi_VN: 'vi',
  fr_FR: 'fr',
};

const resourcesKnox = {
  ko: { contacts: contacts_KR },
  en: { contacts: contacts_US },
  ja: { contacts: contacts_JP },
  zh: { contacts: contacts_CN },
  tw: { contacts: contacts_TW },
  vi: { contacts: contacts_VN },
  fr: { contacts: contacts_FR },
};

const resourcesBrity = {
  ko: { contacts: brity_contacts_KR },
  en: { contacts: brity_contacts_US },
  ja: { contacts: brity_contacts_JP },
  zh: { contacts: brity_contacts_CN },
  tw: { contacts: brity_contacts_TW },
  vi: { contacts: brity_contacts_VN },
  fr: { contacts: brity_contacts_FR },
};

const resourcesGov = {
  ko: { contacts: gov_contacts_KR },
  en: { contacts: gov_contacts_US },
  ja: { contacts: gov_contacts_JP },
  zh: { contacts: gov_contacts_CN },
  tw: { contacts: gov_contacts_TW },
  vi: { contacts: gov_contacts_VN },
  fr: { contacts: gov_contacts_FR },
};

const langConstant = { isKnox, LANGUAGES, resourcesKnox, resourcesBrity, resourcesGov };
export default langConstant;
